module.exports = __webpack_public_path__ + "static/media/7.4631fcc2.jpg";